(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.zhfeCollect = factory());
}(this, (function () { 'use strict';

	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _typeof_1$$1 = createCommonjsModule(function (module) {

	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      module.exports = _typeof = function _typeof(obj) {
	        return typeof obj;
	      };
	    } else {
	      module.exports = _typeof = function _typeof(obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }

	    return _typeof(obj);
	  }

	  module.exports = _typeof;
	});

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	var classCallCheck = _classCallCheck;

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	var createClass = _createClass;

	/** Detect free variable `global` from Node.js. */

	var freeGlobal = _typeof_1$$1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	var _freeGlobal = freeGlobal;

	/** Detect free variable `self`. */

	var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof_1$$1(self)) == 'object' && self && self.Object === Object && self;
	/** Used as a reference to the global object. */

	var root = _freeGlobal || freeSelf || Function('return this')();
	var _root = root;

	/** Built-in value references. */

	var _Symbol2 = _root.Symbol;
	var _Symbol = _Symbol2;

	/** Built-in value references. */

	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

	/** Used for built-in method references. */

	/** Built-in value references. */

	var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */

	/** Used for built-in method references. */

	var funcProto = Function.prototype;
	/** Used to resolve the decompiled source of functions. */

	var funcToString = funcProto.toString;
	/** Used to infer the `Object` constructor. */

	var objectCtorString = funcToString.call(Object);

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */

	var _nodeUtil = createCommonjsModule(function (module, exports) {
	  /** Detect free variable `exports`. */
	  var freeExports = exports && !exports.nodeType && exports;
	  /** Detect free variable `module`. */

	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	  /** Detect the popular CommonJS extension `module.exports`. */

	  var moduleExports = freeModule && freeModule.exports === freeExports;
	  /** Detect free variable `process` from Node.js. */

	  var freeProcess = moduleExports && _freeGlobal.process;
	  /** Used to access faster Node.js helpers. */

	  var nodeUtil = function () {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      } // Legacy `process.binding('util')` for Node.js < 10.


	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }();

	  module.exports = nodeUtil;
	});

	/* Node.js helper references. */

	var nodeIsDate = _nodeUtil && _nodeUtil.isDate;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */

	var _class2type = {};
	'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' ').forEach(function (name, i) {
	  _class2type['[object ' + name + ']'] = name.toLowerCase();
	});

	/**
	 * @function
	 * @name getBaseByUrl
	 * @param {*} url
	 * @returns {string}
	 * @desc 获取Url不含参数部分
	 */
	/**
	 * @function
	 * @name getParamStrByObj
	 * @param {object} obj
	 * @returns {string}
	 * @desc 将对象转换成url参数
	 */

	var getParamStrByObj = function getParamStrByObj(obj) {
	  if (!obj) {
	    return '';
	  }

	  var paramStr = '';
	  var key;

	  for (key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      paramStr += "&".concat(key, "=").concat(obj[key]);
	    }
	  }

	  return paramStr.substring(1);
	};

	var getParamStrByObj$1 = getParamStrByObj;

	var Infoc =
	/*#__PURE__*/
	function () {
	  function Infoc(rootUrl, baseMap, dat) {
	    classCallCheck(this, Infoc);

	    this.root = rootUrl || '';
	    var params = this.generateDatMap(baseMap, dat);
	    this.params = params;
	    this.paramsJsonStr = JSON.stringify(params);
	  }

	  createClass(Infoc, [{
	    key: "generateDatMap",
	    value: function generateDatMap(params, dat) {
	      if (_typeof_1$$1(dat) === 'object') {
	        return Object.assign(params, dat);
	      } else if (typeof dat === 'string') {
	        var firstTableIndexReg = /^([^ :]+):([^ :]*)/;
	        var datReg = /([^ :]+):([^ :]*)/g;
	        var datParams = {};

	        if (!firstTableIndexReg.test(dat)) {
	          return params;
	        }

	        dat = dat.replace(firstTableIndexReg, function (m, tableName, tableIndex) {
	          return "business_index:".concat(tableIndex);
	        });
	        dat.replace(datReg, function (m, key, value) {
	          if (/^string|uuid$/.test(value)) {
	            datParams[key] = '';
	          } else if (key === 'business_index') {
	            datParams[key] = value;
	          } else {
	            datParams[key] = 0;
	          }
	        });
	        var base = {
	          product_no: 0,
	          public_index: 0,
	          business_index: 0
	        };
	        return Object.assign(base, datParams, params);
	      }

	      return {};
	    }
	  }, {
	    key: "getReportUrl",
	    value: function getReportUrl(opt) {
	      var base = JSON.parse(this.paramsJsonStr);
	      var paramObj = Object.assign(base, opt);
	      var url = this.root + '?' + getParamStrByObj$1(paramObj);
	      return url;
	    }
	  }, {
	    key: "report",
	    value: function report(opt, isSync) {
	      var _this = this;

	      var url = this.getReportUrl(opt);

	      if (isSync === true) {
	        this.sendReport(url);
	      } else {
	        setTimeout(function () {
	          _this.sendReport(url);
	        }, 0);
	      }

	      return this;
	    }
	  }, {
	    key: "sendReport",
	    value: function sendReport(url) {
	      if (!url) {
	        return;
	      }

	      var img = new Image();
	      img.src = url;
	      setTimeout(function () {
	        img = null; // 资源回收
	      }, 10000);
	    }
	  }]);

	  return Infoc;
	}();

	var mainReport = function mainReport(rootUrl, param1, param2) {
	  if (!rootUrl) {
	    return null;
	  }

	  var params = {};
	  var dat = {};

	  if (_typeof_1$$1(param1) === 'object') {
	    params = param1;
	    dat = param2;
	  } else if (typeof param1 === 'string') {
	    dat = param1;
	  }

	  return new Infoc(rootUrl, params, dat);
	};

	return mainReport;

})));
